"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideToolbar = void 0;
const pubsub_js_1 = require("pubsub-js");
const ViewerOptions_1 = require("../../objects/ViewerOptions");
const utils_1 = require("../../utils/utils");
const UiElements_1 = require("../ui/UiElements");
const SideToolbarControls_1 = require("./components/SideToolbarControls");
class SideToolbar {
    constructor() {
        this.functions = {
            toggleFullscreen: (ev) => this.toggleFullscreen(ev),
            toggleHd: (ev) => this.toggleHd(ev),
            toggleMenu: (ev) => this.toggleMenu(ev),
            toggleAnnotationSwitcher: (ev) => this.toggleAnnotationSwitcher(ev)
        };
        this.guiLayer = document.getElementById('guiLayer');
        if (!this.guiLayer) {
            throw new Error("GuiLayer is undefined");
        }
        this.sideToolbar = this.createSideToolbarDiv();
        this.sideToolbarControls = new SideToolbarControls_1.SideToolbarControls(this.sideToolbar.domEl);
        this.guiLayer.appendChild(this.sideToolbar.domEl);
        this.addEvents();
    }
    changeIconsColor(bgColor) {
        this.sideToolbar.domEl.style.color = (0, utils_1.colorBasedOnBackground)(bgColor);
    }
    dispose() {
        this.removeEvents();
    }
    createSideToolbarDiv() {
        return new UiElements_1.DivEl().setId('sideToolbar');
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.fullscreenBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.functions.toggleFullscreen);
        (_d = (_c = this.sideToolbarControls) === null || _c === void 0 ? void 0 : _c.hdBtn) === null || _d === void 0 ? void 0 : _d.setEvent('click', this.functions.toggleHd);
        (_f = (_e = this.sideToolbarControls) === null || _e === void 0 ? void 0 : _e.menuBtn) === null || _f === void 0 ? void 0 : _f.setEvent('click', this.functions.toggleMenu);
        (_h = (_g = this.sideToolbarControls) === null || _g === void 0 ? void 0 : _g.annotationsBtn) === null || _h === void 0 ? void 0 : _h.setEvent('click', this.functions.toggleAnnotationSwitcher);
        (0, pubsub_js_1.subscribe)("no-annotations" /* NO_ANNOTATIONS */, () => {
            var _a;
            (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.removeAnnotationsBtn();
        });
        (0, pubsub_js_1.subscribe)("background-changed" /* BACKGROUND_CHANGED */, (_, bgColor) => this.changeIconsColor(bgColor));
        document.onfullscreenchange = () => {
            if (document.fullscreenElement) {
                this.setFullscreenIconActive();
                return;
            }
            this.setFullscreenIconInactive();
        };
    }
    setFullscreenIconActive() {
        var _a;
        (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.fullscreenBtn.domEl.classList.add('active');
    }
    setFullscreenIconInactive() {
        var _a;
        (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.fullscreenBtn.domEl.classList.remove('active');
    }
    toggleHd(event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        const iconEl = (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.hdBtn.domEl.firstChild;
        if (iconEl.classList.contains('ci-sd')) {
            iconEl.classList.replace('ci-sd', 'ci-hd');
            PubSub.publish("change-model-quality" /* CHANGE_MODEL_QUALITY */, "mid" /* MID */);
            return;
        }
        iconEl.classList.replace('ci-hd', 'ci-sd');
        PubSub.publish("change-model-quality" /* CHANGE_MODEL_QUALITY */, "low" /* LOW */);
    }
    toggleMenu(event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        const menuWrapper = document.getElementsByClassName('menu')[0];
        if (!menuWrapper) {
            throw new Error("class menu is undefined. Menu does not exist");
        }
        const closeMenuBtn = document.getElementById('closeMenu');
        closeMenuBtn === null || closeMenuBtn === void 0 ? void 0 : closeMenuBtn.classList.toggle('hidden');
        menuWrapper.classList.toggle('active');
        const guiLayer = document.getElementById('guiLayer');
        if (!guiLayer) {
            return;
        }
        if (guiLayer.clientHeight <= 500) {
            menuWrapper.setAttribute('heightLimit', 'true');
        }
        else {
            menuWrapper.removeAttribute('heightLimit');
        }
        if (ViewerOptions_1.ViewerOptions.viewType === ViewerOptions_1.ViewType.LIGHT) {
            document.getElementById('closeMenu').style.color = '#fff';
        }
        (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.menuBtn.domEl.classList.toggle('active');
    }
    toggleAnnotationSwitcher(event) {
        var _a, _b;
        event.preventDefault();
        event.stopPropagation();
        const annSwitcherEl = document.querySelector('.arc-viewer #annotationSwitcher');
        if (!annSwitcherEl) {
            return;
        }
        PubSub.publish("toggle-annotation-switcher" /* TOGGLE_ANNOTATION_SWITCHER */);
        if (annSwitcherEl.classList.contains('active')) {
            (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.annotationsBtn.domEl.classList.remove('active');
        }
        else {
            (_b = this.sideToolbarControls) === null || _b === void 0 ? void 0 : _b.annotationsBtn.domEl.classList.add('active');
        }
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.fullscreenBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.functions.toggleFullscreen);
        (_d = (_c = this.sideToolbarControls) === null || _c === void 0 ? void 0 : _c.hdBtn) === null || _d === void 0 ? void 0 : _d.removeEvent('click', this.functions.toggleHd);
        (_f = (_e = this.sideToolbarControls) === null || _e === void 0 ? void 0 : _e.menuBtn) === null || _f === void 0 ? void 0 : _f.removeEvent('click', this.functions.toggleMenu);
        (_h = (_g = this.sideToolbarControls) === null || _g === void 0 ? void 0 : _g.annotationsBtn) === null || _h === void 0 ? void 0 : _h.removeEvent('click', this.functions.toggleAnnotationSwitcher);
    }
    toggleFullscreen(event) {
        var _a, _b;
        event.preventDefault();
        event.stopPropagation();
        if (!((_a = this.sideToolbarControls) === null || _a === void 0 ? void 0 : _a.fullscreenBtn)) {
            return;
        }
        const viewer = (_b = document.getElementsByClassName('layer-wrapper')[0]) === null || _b === void 0 ? void 0 : _b.parentElement;
        if (!viewer) {
            return;
        }
        if (document.fullscreenElement) {
            document.exitFullscreen();
            return;
        }
        viewer.requestFullscreen();
    }
}
exports.SideToolbar = SideToolbar;
